angular.module('impactx.login').controller('LogoutOpenIdCtrl', LogoutOpenIdCtrl);

LogoutOpenIdCtrl.$inject = ['$scope', 'dataGen', '$routeParams'];

function LogoutOpenIdCtrl($scope, dataGen, $routeParams) {
    dataGen.getData($scope, {sid: $routeParams.sid, iss: $routeParams.iss}, "/login/openid/logoutfront");
}